import { render, staticRenderFns } from "./dlList.vue?vue&type=template&id=61d1465b"
import script from "./dlList.vue?vue&type=script&lang=js"
export * from "./dlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports